<template>
  <div>
    <el-row style="margin-bottom:20px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/director-workmaster' }">工作通</el-breadcrumb-item>
        <el-breadcrumb-item>招标</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
    <!-- logo -->
    <div class="top">
      <div>
        <img
          src="@/assets/community/back.png"
          alt=""
          class="top-left-img"
          @click="back"
        />
      </div>
      <div>
        <img src="@/assets/tender/tender.png" alt="" class="top-midlle-img" />
      </div>
      <div class="top-midlle-span">提交记录</div>
    </div>
    <!-- 中间 -->
    <div class="middle">
      <!-- 左半部分 -->
      <div class="middle-left">
        <!-- 选择器 -->
        <div class="selector">
          <el-select v-model="searchFormData.status" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <!-- 搜索 -->
        <div class="seach">
          <el-input
            v-model="searchFormData.title"
            placeholder="请输入招标名称"
          ></el-input>
          <el-button type="primary" @click="onSearch()">搜索</el-button>
        </div>
      </div>
    </div>
    <!-- 表格 -->
    <div class="bottom">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="title" label="标题" width="250px">
        </el-table-column>
        <el-table-column prop="description" label="简介"> </el-table-column>
        <el-table-column prop="status" label="状态">
          <!--0 审核中 1 招标中 2 已取消,3已拒绝,4已驳回-->
          <template slot-scope="{ row }">
            <span v-if="row.status == 0" style="color: #ff9004">审核中</span>
            <span v-if="row.status == 1" style="color: green">招标中</span>
            <span v-else-if="row.status == 2" style="color: gray">已取消</span>
            <span v-else-if="row.status == 3" style="color: red">已拒绝</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          align="center"
          class-name="small-padding "
        >
          <template slot-scope="{ row }">
            <el-button type="text" size="mini" @click="godetail(row.crowd_id)">
              详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="paging">
      <!--分页-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="searchFormData.page"
        :page-size="searchFormData.limit"
        layout="total, prev, pager, next"
        :total="searchFormData.total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { webCrowdOperateList } from "@/api/director/package/index";
export default {
  data() {
    return {
      options: [
        {
          value: "1",
          label: "进行中",
        },
        {
          value: "2",
          label: "待选标",
        },
        {
          value: "3",
          label: "已结束",
        },
      ],

     

      searchFormData: {
        title:'',
        status:"",
        corpor_id: "", //	社团id
        mode: 1, //1招标列表，2帮忙列表
        page: 1, //页数
        limit: 10, //	每页条数
        total: 0,
      },
      tableData: [],

      
    };
  },

  mounted() {
    console.log(this.$route.query)
    if (this.$route.query.corpor_id != "") {
      this.corpor_id = this.$route.query.corpor_id;
      this.searchFormData.corpor_id=this.corpor_id ;
      this.fetchData();

      // 获取接口
    }
  },
  methods: {
    fetchData() {
      webCrowdOperateList(this.searchFormData).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.tableData = res.data.data;
          this.searchFormData.total = res.data.total;
        } else {
          this.$message.error(res.msg ? res.msg : "请求错误");
        }
      });
    },
    onSearch() {
      if (this.searchFormData.title != "") {
        this.fetchData();
      } else {
        this.$message.error("请输入招标名称");
      }
    },
    // 当前页变更
    handleCurrentChange(num) {
      this.searchFormData.page = num;
      this.fetchData();
    },

    // 每页显示页面数变更
    handleSizeChange(size) {
      this.searchFormData.limit = size;
      this.fetchData();
    },
    back() {
      this.$router.go(-1);
    },
    godetail(crowd_id) {
      this.$router.push( { name: "bidding-records-detail", query: { crowd_id: crowd_id} } );
      
    },
  },
};
</script>

<style lang="scss" scoped>
.top {
  width: 950px;
  height: 31px;
  display: flex;
}

.top-left-img {
  margin-top: 8px;
  width: 25px;
  height: 25px;
}

.top-midlle-img {
  width: 40px;
  height: 40px;
}

.top-midlle-span {
  margin-left: 20px;
  margin-top: 8px;
  height: 16px;
  font-size: 16px;
  color: #181818;
  font-weight: bold;
}

.top-right {
  margin-top: 2px;
  margin-left: 740px;
}

.middle {
  margin-top: 40px;
  display: flex;
  justify-content: space-between;

  .middle-left {
    display: flex;

    .selector {
      width: 100px;
      height: 28px;
      margin-left: 25px;
    }

    ::v-deep .el-input__inner {
      color: #181818;
    }

    .seach {
      // width: 192px;
      // height: 28px;
      display: flex;
      margin-left: 19px;

      .el-button--small {
        margin-left: 13px;
      }
    }
  }
}

.middle[data-v-cc741ad6] {
  width: 100%;
}

.bottom {
  margin-top: 26px;
  margin-left: 25px;
}

.paging {
  margin-top: 50px;
  display: flex;
  justify-content: flex-end;
}
</style>
